module.exports = __webpack_public_path__ + "static/media/ibm_plex_sans.2526ba23.ttf";